import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

/**
 * React Query key for the `GET /api/portal/me` snapshot. Exported so
 * mutation hooks that need to invalidate the portal snapshot (e.g. after
 * creating a pet) can reference it directly.
 */
export const meQueryKey = ['me'] as const

/**
 * Loads the signed-in member's profile, patients, and upcoming
 * appointments via `GET /api/portal/me`. Callers control firing via
 * the `enabled` option; defaults to true.
 */
export function useGetMe(options: { enabled?: boolean } = {}) {
  const api = usePortalApi()
  return useQuery({
    queryKey: meQueryKey,
    enabled: options.enabled ?? true,
    queryFn: async () => dataOrThrow(await api.get('/me')),
  })
}
